import { User } from 'lucide-react';

interface AvatarProps {
  url?: string | null;
  name?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-16 h-16 text-xl',
  xl: 'w-24 h-24 text-3xl',
};

export function Avatar({ url, name, size = 'md', className = '' }: AvatarProps) {
  const initial = name?.trim().charAt(0).toUpperCase() ?? '';

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-emerald-glow/15 border border-emerald-glow/30 flex items-center justify-center overflow-hidden shrink-0 ${className}`}
    >
      {url ? (
        <img
          src={url}
          alt={name ?? 'avatar'}
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      ) : initial ? (
        <span className="font-display font-bold text-emerald-glow">{initial}</span>
      ) : (
        <User className="text-emerald-glow" size={size === 'sm' ? 14 : size === 'md' ? 18 : 28} />
      )}
    </div>
  );
}
